module.exports = __webpack_public_path__ + "img/ico_exclamination.38d04bf6.svg";